
import { mapState, mapActions, mapGetters } from 'vuex';
import ReviewAllowedAuthorType from '@/enums/ReviewAllowedAuthorType';

export default {
  name: 'AppNewReviewButton',
  props: {
    label: {
      type: String,
      default: null
    },
    subOrderId: {
      type: Number,
      default: null
    },
    productCode: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapGetters('session', ['isLoginRequired', 'isLoggedIn']),
    isNonmemberConfirmRequired() {
      // TODO: 레거시 리뷰 작성창은 자체적으로 비회원 확인을 하므로 중복을 피해 건너뛴다.
      // 모든 브랜드가 v2 작성창으로 전환되면 이 가드를 제거한다.
      if (!this.reviewSettings.review_form_enabled) return false;

      return (
        !this.isLoggedIn &&
        this.reviewSettings.allowed_author_type ===
          ReviewAllowedAuthorType.EVERYONE
      );
    }
  },
  methods: {
    ...mapActions('dialog', ['openNewReviewPopup']),
    ...mapActions('widget', ['confirmForLogin']),
    confirmForNonmemberReview() {
      return this.windowService.confirm(
        this.$t('app.require_nonmember_review_confirmation')
      );
    },
    async onClickNewReviewBtn() {
      if (this.isLoginRequired) {
        this.confirmForLogin();
        return;
      }

      if (this.isNonmemberConfirmRequired) {
        const confirmed = await this.confirmForNonmemberReview();
        if (!confirmed) return;
      }

      this.openNewReviewPopup({
        subOrderId: this.subOrderId,
        productCode: this.productCode
      });
    }
  }
};
